<div class="p-0">
  <div class="m-t-20">
    <div class="row">

      <div class="col-lg-12">

        <mat-card *ngIf="note18" class="b-0">
          <mat-card-content class="p-0">

            <div class="p-0 p-x-10 b-0" style="max-height: 650px; overflow-y: auto;">
              <div class="p-0 b-1 m-b-20" style="border-radius: 10px;">
                <div class="p-10 d-flex justify-content-between align-items-center" style="background: aliceblue; border-radius: 10px 10px 0px 0px;">
                  <h4 class="f-s-15 f-w-600">
                    Analysis of Receipts of Government Grants
                  </h4>
                </div>
                <mat-card class="cardWithShadow m-t-10 m-x-10" style="border-radius: 10px;">
                  <mat-card-content class="p-0">
                    <div class="table-responsive w-100" style="border-radius: 10px;">
                      <table mat-table [dataSource]="data" class="w-100">
                        <ng-container matColumnDef="id">
                          <th mat-header-cell *matHeaderCellDef class="f-s-12 f-w-500">
                          </th>
                          <td mat-cell *matCellDef="let element" class="text-left" style="text-wrap: pretty;">
                            {{element.type}}
                          </td>
                          <td mat-footer-cell *matFooterCellDef class="f-w-600">Total</td>
                        </ng-container>

                        <ng-container matColumnDef="Description">
                          <th mat-header-cell *matHeaderCellDef class="f-s-12 f-w-500 text-center">
                            Description
                          </th>
                          <td mat-cell *matCellDef="let element" class="text-left">
                            <mat-form-field appearance="outline" class="hide-hint bg-white w-100" style="border-radius: 10px;">
                              <input matInput type="text" />
                            </mat-form-field>
                          </td>
                          <td mat-footer-cell *matFooterCellDef class="f-w-600"></td>
                        </ng-container>

                        <ng-container matColumnDef="year">
                          <th mat-header-cell *matHeaderCellDef class="f-s-12 f-w-500 text-center">
                            This Year (&pound;)
                          </th>
                          <td mat-cell *matCellDef="let element" class="text-left w130">
                            <mat-form-field appearance="outline" class="hide-hint bg-white w-100" style="border-radius: 10px;">
                              <input matInput type="number" />
                            </mat-form-field>
                          </td>
                          <td mat-footer-cell *matFooterCellDef class="f-w-600">
                            <mat-form-field appearance="outline" class="hide-hint bg-white w-100" style="border-radius: 10px;">
                              <input matInput type="number" />
                            </mat-form-field>
                          </td>
                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="displayedColumns" style="background: aliceblue !important;"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
                        <tr mat-footer-row *matFooterRowDef="displayedColumns" style="background: #f1f1f1;"></tr>

                      </table>
                    </div>

                  </mat-card-content>
                </mat-card>

                <mat-card class="cardWithShadow m-t-10 m-x-10" style="border-radius: 10px;">
                  <mat-card-content class="p-0">
                    <div class="table-responsive w-100" style="border-radius: 10px;">
                      <table mat-table [dataSource]="data2" class="w-100">
                        <ng-container matColumnDef="id">
                          <th mat-header-cell *matHeaderCellDef class="f-s-12 f-w-500">
                          </th>
                          <td mat-cell *matCellDef="let element" class="text-left" style="text-wrap: pretty;">
                            {{element.type}}
                          </td>
                          <td mat-footer-cell *matFooterCellDef class="f-w-600">Total</td>
                        </ng-container>

                        <ng-container matColumnDef="Description">
                          <th mat-header-cell *matHeaderCellDef class="f-s-12 f-w-500 text-center">
                            Description
                          </th>
                          <td mat-cell *matCellDef="let element" class="text-left">
                            <mat-form-field appearance="outline" class="hide-hint bg-white w-100" style="border-radius: 10px;">
                              <input matInput type="text" />
                            </mat-form-field>
                          </td>
                          <td mat-footer-cell *matFooterCellDef class="f-w-600"></td>
                        </ng-container>

                        <ng-container matColumnDef="year">
                          <th mat-header-cell *matHeaderCellDef class="f-s-12 f-w-500 text-center">
                            This Year (&pound;)
                          </th>
                          <td mat-cell *matCellDef="let element" class="text-left w130">
                            <mat-form-field appearance="outline" class="hide-hint bg-white w-100" style="border-radius: 10px;">
                              <input matInput type="number" />
                            </mat-form-field>
                          </td>
                          <td mat-footer-cell *matFooterCellDef class="f-w-600">
                            <mat-form-field appearance="outline" class="hide-hint bg-white w-100" style="border-radius: 10px;">
                              <input matInput type="number" />
                            </mat-form-field>
                          </td>
                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="displayedColumns2" style="background: aliceblue !important;"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumns2"></tr>
                        <tr mat-footer-row *matFooterRowDef="displayedColumns2" style="background: #f1f1f1;"></tr>

                      </table>
                    </div>

                  </mat-card-content>
                </mat-card>

                <mat-card class="cardWithShadow m-t-10 m-x-10" style="border-radius: 10px;">
                  <mat-card-content class="p-0">
                    <div class="table-responsive w-100" style="border-radius: 10px;">
                      <table mat-table [dataSource]="data3" class="w-100">
                        <ng-container matColumnDef="id">
                          <th mat-header-cell *matHeaderCellDef class="f-s-12 f-w-500">
                          </th>
                          <td mat-cell *matCellDef="let element" class="text-left" style="text-wrap: pretty; width: 30%;">
                            {{element.type}}
                          </td>
                        </ng-container>

                        <ng-container matColumnDef="thisYear">
                          <th mat-header-cell *matHeaderCellDef class="f-s-12 f-w-500 text-center">
                            This Year
                          </th>
                          <td mat-cell *matCellDef="let element" class="text-left w130">
                            <mat-form-field class="p-x-0 bg-white example-full-width w-100 m-t-16" appearance="outline">
                              <textarea matInput rows="4" value="" class="text-left"  maxlength="2500"></textarea>
                            </mat-form-field>
                          </td>
                        </ng-container>

                        <ng-container matColumnDef="LastYear">
                          <th mat-header-cell *matHeaderCellDef class="f-s-12 f-w-500 text-center">
                            Last Year
                          </th>
                          <td mat-cell *matCellDef="let element" class="text-left w130">
                            <mat-form-field class="p-x-0 bg-white example-full-width w-100 m-t-16" appearance="outline">
                              <textarea matInput rows="4" value="" class="text-left"></textarea>
                            </mat-form-field>
                          </td>
                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="displayedColumns3" style="background: aliceblue !important;"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumns3"></tr>

                      </table>
                    </div>

                  </mat-card-content>
                </mat-card>

                <mat-card class="cardWithShadow m-t-10 m-x-10" style="border-radius: 10px;">
                  <mat-card-content class="p-0">
                    <div class="table-responsive w-100" style="border-radius: 10px;">
                      <table mat-table [dataSource]="data4" class="w-100">
                        <ng-container matColumnDef="id">
                          <th mat-header-cell *matHeaderCellDef class="f-s-12 f-w-500">
                          </th>
                          <td mat-cell *matCellDef="let element" class="text-left" style="text-wrap: pretty; width: 30%;">
                            {{element.type}}
                          </td>
                        </ng-container>

                        <ng-container matColumnDef="thisYear">
                          <th mat-header-cell *matHeaderCellDef class="f-s-12 f-w-500 text-center">
                            This Year
                          </th>
                          <td mat-cell *matCellDef="let element" class="text-left w130">
                            <mat-form-field class="p-x-0 bg-white example-full-width w-100 m-t-16" appearance="outline">
                              <textarea matInput rows="4" value="" class="text-left" maxlength="2500"></textarea>
                            </mat-form-field>
                          </td>
                        </ng-container>

                        <ng-container matColumnDef="LastYear">
                          <th mat-header-cell *matHeaderCellDef class="f-s-12 f-w-500 text-center">
                            Last Year
                          </th>
                          <td mat-cell *matCellDef="let element" class="text-left w130">
                            <mat-form-field class="p-x-0 bg-white example-full-width w-100 m-t-16" appearance="outline">
                              <textarea matInput rows="4" value="" class="text-left"></textarea>
                            </mat-form-field>
                          </td>
                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="displayedColumns4" style="background: aliceblue !important;"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumns4"></tr>

                      </table>
                    </div>

                  </mat-card-content>
                </mat-card>
              </div>
            </div>
          </mat-card-content>
        </mat-card>

        <mat-card *ngIf="note19" class="b-0">
          <mat-card-content class="p-0">

            <div class="p-0 p-x-10 b-0" style="max-height: 650px; overflow-y: auto;">
              <div class="p-0 b-1 m-b-20" style="border-radius: 10px;">
                <div class="p-10 d-flex justify-content-between align-items-center" style="background: aliceblue; border-radius: 10px 10px 0px 0px;">
                  <h4 class="f-s-15 f-w-600">
                    Donated goods, facilities and services
                  </h4>
                </div>
                <mat-card class="cardWithShadow m-t-10 m-x-10" style="border-radius: 10px;">
                  <mat-card-content class="p-0">
                    <div class="table-responsive w-100" style="border-radius: 10px;">
                      <table mat-table [dataSource]="note5data" class="w-100">
                        <ng-container matColumnDef="id">
                          <th mat-header-cell *matHeaderCellDef class="f-s-12 f-w-500">
                          </th>
                          <td mat-cell *matCellDef="let element" class="text-left" style="text-wrap: pretty;">
                            {{element.type}}
                          </td>
                          <td mat-footer-cell *matFooterCellDef class="f-w-600">Total</td>
                        </ng-container>

                        <ng-container matColumnDef="thisYear">
                          <th mat-header-cell *matHeaderCellDef class="f-s-12 f-w-500 text-center">
                            This Year (&pound;)
                          </th>
                          <td mat-cell *matCellDef="let element" class="text-left w130">
                            <mat-form-field appearance="outline" class="hide-hint bg-white w-100" style="border-radius: 10px;">
                              <input matInput type="number" />
                            </mat-form-field>
                          </td>
                          <td mat-footer-cell *matFooterCellDef class="f-w-600">
                            <mat-form-field appearance="outline" class="hide-hint bg-white w-100" style="border-radius: 10px;">
                              <input matInput type="number" />
                            </mat-form-field>
                          </td>
                        </ng-container>

                        <ng-container matColumnDef="lastYear">
                          <th mat-header-cell *matHeaderCellDef class="f-s-12 f-w-500 text-center">
                            Last Year (&pound;)
                          </th>
                          <td mat-cell *matCellDef="let element" class="text-left w130">
                            <mat-form-field appearance="outline" class="hide-hint bg-white w-100" style="border-radius: 10px;">
                              <input matInput type="number" />
                            </mat-form-field>
                          </td>
                          <td mat-footer-cell *matFooterCellDef class="f-w-600">
                            <mat-form-field appearance="outline" class="hide-hint bg-white w-100" style="border-radius: 10px;">
                              <input matInput type="number" />
                            </mat-form-field>
                          </td>
                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="note5displayedColumns" style="background: aliceblue !important;"></tr>
                        <tr mat-row *matRowDef="let row; columns: note5displayedColumns"></tr>
                        <tr mat-footer-row *matFooterRowDef="note5displayedColumns" style="background: #f1f1f1;"></tr>

                      </table>
                    </div>

                  </mat-card-content>
                </mat-card>

                <mat-card class="cardWithShadow m-t-10 m-x-10" style="border-radius: 10px;">
                  <mat-card-content class="p-0">
                    <div class="table-responsive w-100" style="border-radius: 10px;">
                      <table mat-table [dataSource]="note5data2" class="w-100">
                        <ng-container matColumnDef="id">
                          <th mat-header-cell *matHeaderCellDef class="f-s-12 f-w-500">
                          </th>
                          <td mat-cell *matCellDef="let element" class="text-left" style="text-wrap: pretty; width: 30%;">
                            {{element.type}}
                          </td>
                        </ng-container>

                        <ng-container matColumnDef="thisYear">
                          <th mat-header-cell *matHeaderCellDef class="f-s-12 f-w-500 text-center">
                            This Year
                          </th>
                          <td mat-cell *matCellDef="let element" class="text-left w130">
                            <mat-form-field class="p-x-0 bg-white example-full-width w-100 m-t-16" appearance="outline">
                              <textarea matInput rows="4" value="" class="text-left"  maxlength="2500"></textarea>
                            </mat-form-field>
                          </td>
                        </ng-container>

                        <ng-container matColumnDef="LastYear">
                          <th mat-header-cell *matHeaderCellDef class="f-s-12 f-w-500 text-center">
                            Last Year
                          </th>
                          <td mat-cell *matCellDef="let element" class="text-left w130">
                            <mat-form-field class="p-x-0 bg-white example-full-width w-100 m-t-16" appearance="outline">
                              <textarea matInput rows="4" value="" class="text-left"></textarea>
                            </mat-form-field>
                          </td>
                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="note5displayedColumns2" style="background: aliceblue !important;"></tr>
                        <tr mat-row *matRowDef="let row; columns: note5displayedColumns2"></tr>

                      </table>
                    </div>

                  </mat-card-content>
                </mat-card>

                <mat-card class="cardWithShadow m-t-10 m-x-10" style="border-radius: 10px;">
                  <mat-card-content class="p-0">
                    <div class="table-responsive w-100" style="border-radius: 10px;">
                      <table mat-table [dataSource]="note5data3" class="w-100">
                        <ng-container matColumnDef="id">
                          <th mat-header-cell *matHeaderCellDef class="f-s-12 f-w-500">
                          </th>
                          <td mat-cell *matCellDef="let element" class="text-left" style="text-wrap: pretty; width: 30%;">
                            {{element.type}}
                          </td>
                        </ng-container>

                        <ng-container matColumnDef="thisYear">
                          <th mat-header-cell *matHeaderCellDef class="f-s-12 f-w-500 text-center">
                            This Year
                          </th>
                          <td mat-cell *matCellDef="let element" class="text-left w130">
                            <mat-form-field class="p-x-0 bg-white example-full-width w-100 m-t-16" appearance="outline">
                              <textarea matInput rows="4" value="" class="text-left"  maxlength="2500"></textarea>
                            </mat-form-field>
                          </td>
                        </ng-container>

                        <ng-container matColumnDef="LastYear">
                          <th mat-header-cell *matHeaderCellDef class="f-s-12 f-w-500 text-center">
                            Last Year
                          </th>
                          <td mat-cell *matCellDef="let element" class="text-left w130">
                            <mat-form-field class="p-x-0 bg-white example-full-width w-100 m-t-16" appearance="outline">
                              <textarea matInput rows="4" value="" class="text-left"></textarea>
                            </mat-form-field>
                          </td>
                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="note5displayedColumns3" style="background: aliceblue !important;"></tr>
                        <tr mat-row *matRowDef="let row; columns: note5displayedColumns3"></tr>

                      </table>
                    </div>

                  </mat-card-content>
                </mat-card>

                <mat-card class="cardWithShadow m-t-10 m-x-10" style="border-radius: 10px;">
                  <mat-card-content class="p-0">
                    <div class="table-responsive w-100" style="border-radius: 10px;">
                      <table mat-table [dataSource]="note5data4" class="w-100">
                        <ng-container matColumnDef="id">
                          <th mat-header-cell *matHeaderCellDef class="f-s-12 f-w-500">
                          </th>
                          <td mat-cell *matCellDef="let element" class="text-left" style="text-wrap: pretty; width: 30%;">
                            {{element.type}}
                          </td>
                        </ng-container>

                        <ng-container matColumnDef="thisYear">
                          <th mat-header-cell *matHeaderCellDef class="f-s-12 f-w-500 text-center">
                            This Year
                          </th>
                          <td mat-cell *matCellDef="let element" class="text-left w130">
                            <mat-form-field class="p-x-0 bg-white example-full-width w-100 m-t-16" appearance="outline">
                              <textarea matInput rows="4" value="" class="text-left"  maxlength="2500"></textarea>
                            </mat-form-field>
                          </td>
                        </ng-container>

                        <ng-container matColumnDef="LastYear">
                          <th mat-header-cell *matHeaderCellDef class="f-s-12 f-w-500 text-center">
                            Last Year
                          </th>
                          <td mat-cell *matCellDef="let element" class="text-left w130">
                            <mat-form-field class="p-x-0 bg-white example-full-width w-100 m-t-16" appearance="outline">
                              <textarea matInput rows="4" value="" class="text-left"></textarea>
                            </mat-form-field>
                          </td>
                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="note5displayedColumns4" style="background: aliceblue !important;"></tr>
                        <tr mat-row *matRowDef="let row; columns: note5displayedColumns4"></tr>

                      </table>
                    </div>

                  </mat-card-content>
                </mat-card>
              </div>
            </div>
          </mat-card-content>
        </mat-card>

      </div>
    </div>
    <div class="row">
      <div class="col-lg-12">
        <mat-card class="b-0">
          <mat-card-content class="p-0">

            <div class="row p-16">

              <div class="col-sm-12 col-md-4">
                <button mat-flat-button color="primary" class="bg-warning text-end" (click)="BackNote()">
                  <!--<button mat-flat-button color="primary" class="bg-warning text-end" (click)="backToSelectNotes()">-->
                  <div class="d-flex text-black">
                    <i-tabler class="icon-20 m-r-4 m-t-0 " name="arrow-left"></i-tabler><span class="f-s-12 text-black"> Back</span>
                  </div>
                </button>
              </div>
              <div class="col-sm-12 col-md-8" align="right">
                <button mat-flat-button color="primary" class="bgwhite border-light b-1 text-end m-r-10">
                  <div class="d-flex text-black">
                    <i-tabler class="icon-20 m-r-4 m-t-0 text-dark" name="device-floppy"></i-tabler><span class="f-s-14 text-dark"> Save as Draft</span>
                  </div>
                </button>
                <button mat-flat-button color="primary" class="bg-success rounded-5" (click)="SaveandNextNote(null,true)">
                  <!--<button mat-flat-button color="primary" class="bg-success rounded-5"  (click)="emitClickEvent('note11')">-->
                  <div class="d-flex text-black">
                    <i-tabler class="icon-20 m-r-4 m-t-0 text-white" name="arrow-right"></i-tabler><span class="f-s-14 text-white"> Save &amp; Next</span>
                  </div>
                </button>
              </div>
            </div>

          </mat-card-content>
        </mat-card>
      </div>
    </div>

  </div>
</div>
